import React from "react";
import { Link } from "react-router-dom";
import homeImageBackground from "../../assets/images/homeBackground.png";
import Header from "../../components/Header";
import Layout from "../../components/Layout";

// import PageIllustration from '../partials/PageIllustration';
// import Footer from '../partials/Footer';

function ChoppingBlock() {
  return (
    <Layout>
      <section className="relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="pt-32 pb-12 md:pt-40 md:pb-20">
            <div className="max-w-3xl mx-auto flex flex-col justify-center items-center text-center">
              <h1
                className="h1 text-gray-200 mb-4"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                Coming Soon
              </h1>
              <p
                className="text-lg text-gray-400"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                Head to our{" "}
                <Link
                  to="/"
                  className="text-orange-600 hover:text-gray-200 transition duration-150 ease-in-out"
                >
                  homepage
                </Link>{" "}
                that does exist
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default ChoppingBlock;
